import {
  Anchor,
  Heading,
  Section,
  SubHeading,
  UnorderedList
} from '~/components/Prefabs';

export default function AboutUsGerman() {
  return (
    <>
      <h1 className="text-title-lg">Über The Sole Supplier</h1>
      <Section>
        <p>
          The Sole Supplier wurde 2013 gegründet, mit dem Ziel, präzise
          Informationen zu Sneaker-Releases und Neuigkeiten für den britischen
          und europäischen Markt bereitzustellen. Unsere Community aus Partnern
          (Marken und Enthusiasten) liefert uns täglich neue und exklusive
          Inhalte – ergänzt durch unser engagiertes Inhouse-Team von Experten.
        </p>
        <p>
          Kuratiertes Angebot und sorgfältige Auswahl sind entscheidende
          Prozesse für The Sole Supplier. Jedes Produkt auf unserer Website wird
          sorgfältig ausgewählt, unter Berücksichtigung von Tradition,
          Modetrends, Zielgruppen und kulturellem Erbe. Durch die Zusammenarbeit
          mit über 50 verschiedenen Online-Händlern bieten wir stets aktuelle
          Release-Informationen zu den begehrtesten Sneakern aus ganz Europa.
          Unsere Release-Dates-Sektion hat sich zu einer wichtigen Anlaufstelle
          für die Sneaker- und Streetwear-Community entwickelt – besonders für
          alle, die immer auf dem neuesten Stand bleiben möchten.{' '}
        </p>
        <p>
          Die News-Sektion von The Sole Supplier ist die erste Anlaufstelle für
          alle Gerüchte und brandaktuellen Informationen aus der Sneaker-Welt.
          Hier finden Besucher eine Vielzahl an geleakten Bildern,
          Release-Gerüchten und Experten-Reviews von unserem vertrauenswürdigen
          Team. Auch Video-Content spielt eine zentrale Rolle, um einen noch
          dynamischeren, informativen und visuellen Einblick in die neuesten
          Trends der Sneaker-Szene zu bieten.{' '}
        </p>
        <p>
          Die The Sole Supplier iOS-App wurde Ende 2018 neu gelauncht, um der
          Sneaker-Community ein noch reibungsloseres Nutzererlebnis zu bieten.
          Über unsere App liefern wir ebenfalls die neuesten Releases,
          Launch-Daten und bestätigten Retailer, damit unsere Nutzer keinen
          wichtigen Drop verpassen.
        </p>
      </Section>
      <Heading>Kontakt</Heading>
      <Section>
        <p>
          Für allgemeine Anfragen oder weitere Informationen können Sie uns
          unter{' '}
          <Anchor href="mailto:info@thesolesupplier.co.uk">
            info@thesolesupplier.co.uk
          </Anchor>{' '}
          kontaktieren.
        </p>
        <p>
          Für Werbeanfragen oder zur Anforderung eines Media-Kits kontaktieren
          <br /> Sie bitte:{' '}
          <Anchor href="mailto:christian@thesolesupplier.co.uk">
            christian@thesolesupplier.co.uk
          </Anchor>
        </p>
      </Section>
      <Heading>Redaktionsrichtlinien</Heading>
      <Section>
        <p>
          Seit der Gründung im Jahr 2013 hat sich The Sole Supplier das Ziel
          gesetzt, die aktuellsten Sneaker-News und Release-Informationen für
          den britischen und europäischen Markt bereitzustellen. Wir sind die
          schnellste und umfassendste Plattform für Sneaker-Informationen und
          liefern täglich exklusive Inhalte zu Sneaker-Releases.
        </p>
        <p>
          The Sole Supplier verpflichtet sich zu höchsten redaktionellen
          Standards und stellt sicher, dass unsere Nachrichten und Inhalte
          präzise und wahrheitsgemäß sind. Als Sneaker-Experten sind wir
          leidenschaftlich bei der Erstellung unserer Inhalte und möchten
          unseren Lesern gut recherchierte und aktuelle Sneaker-News liefern.
          Wir leben und atmen Sneakers – deshalb legen wir großen Wert auf
          unsere redaktionellen Grundsätze und Prozesse.
        </p>
      </Section>
      <SubHeading>Redaktionelle Grundsätze</SubHeading>
      <Section>
        <p>Unsere redaktionellen Grundsätze sind:</p>
        <p>
          <UnorderedList>
            <li>Genauigkeit</li>
            <li>Unparteilichkeit</li>
            <li>Transparenz</li>
            <li>Verantwortlichkeit</li>
            <li>Originalität</li>
          </UnorderedList>
        </p>
        <p>
          Wir arbeiten kontinuierlich daran, sicherzustellen, dass unsere
          Inhalte präzise, unparteiisch und transparent sind und dass wir
          unseren Lesern gegenüber voll verantwortlich handeln. Unsere Artikel
          und News sind einzigartig und unabhängig und richten sich an ein
          Publikum, das Sneakers genauso liebt wie wir.
        </p>
      </Section>
      <SubHeading>Redaktioneller Prozess</SubHeading>
      <Section>
        <p>
          Um sicherzustellen, dass wir unsere redaktionellen Grundsätze
          konsequent einhalten, hat The Sole Supplier einen klaren und
          strukturierten redaktionellen Prozess:
        </p>
      </Section>
      <SubHeading>Planung</SubHeading>
      <Section>
        <p>
          Wir führen einen detaillierten Redaktionskalender, der uns ermöglicht,
          unsere Artikel über längere Zeiträume hinweg sorgfältig zu planen und
          zu strukturieren. Gleichzeitig bleiben wir flexibel, um auf aktuelle
          Nachrichten und Trends schnell reagieren zu können.
        </p>
      </Section>
      <SubHeading>Recherche</SubHeading>
      <Section>
        <p>
          Bevor wir mit dem Schreiben beginnen, führen wir eine gründliche
          Recherche zu jedem Thema durch. Alle Inhalte werden sorgfältig
          geprüft, um höchste Genauigkeit und Faktentreue zu gewährleisten.{' '}
        </p>
      </Section>
      <SubHeading>Erstellung</SubHeading>
      <Section>
        <p>
          Nach der Recherche und Planung wird der Artikel oder die News von
          unserem spezialisierten Sneaker-Team verfasst.
        </p>
      </Section>
      <SubHeading>Visuelle Inhalte</SubHeading>
      <Section>
        <p>
          Während der Produktion suchen wir nach passenden Bildern und Grafiken,
          holen gegebenenfalls Genehmigungen ein oder erstellen unsere eigenen
          visuellen Inhalte, um jedem Artikel eine einzigartige visuelle Note zu
          verleihen.
        </p>
      </Section>
      <SubHeading>Bearbeitung und Freigabe</SubHeading>
      <Section>
        <p>
          Nach der Erstellung wird jeder Artikel von unserem Senior-Team
          überprüft und bearbeitet. Dabei achten wir auf Genauigkeit, Tonalität,
          Präsentation und Grammatik/Rechtschreibung. Erst nach der finalen
          Genehmigung durch einen Redakteur wird der Artikel entweder sofort
          veröffentlicht oder für einen bestimmten Termin eingeplant.
        </p>
      </Section>
      <SubHeading>Überprüfung und Moderation</SubHeading>
      <Section>
        <p>
          Nach der Veröffentlichung wird jeder Artikel nochmals überprüft, um
          sicherzustellen, dass alle Inhalte korrekt dargestellt werden. Wir
          nehmen außerdem Feedback unserer Community auf Social Media entgegen
          und werten es aus, um unsere Inhalte kontinuierlich zu verbessern und
          zukünftige Veröffentlichungen gezielt an den Interessen unserer Leser
          auszurichten.
        </p>
      </Section>
      <Heading>Werberichtlinien</Heading>
      <Section>
        <p>
          Wir erstellen Inhalte, die für dich von Interesse sind, mit einem
          Fokus auf die neuesten News, Trends, Marken, Produktveröffentlichungen
          und Angebote.
        </p>
        <p>
          Wir berichten über Produkte und Dienstleistungen, die für dich
          relevant sein könnten, und helfen dir, sie zu finden. Dies bedeutet,
          dass wir manchmal Links zu diesen Produkten in unseren Artikeln
          einfügen. Diese Links können sogenannte Affiliate-Links sein. Wenn du
          über diese Links auf die Website eines anderen Unternehmens gehst oder
          ein Produkt kaufst, erhalten wir möglicherweise eine Provision von
          diesem Unternehmen.
        </p>
        <p>Wichtige Hinweise:</p>
        <p>
          <UnorderedList>
            <li>
              Wir erhalten nicht für alle Verkäufe eine Provision, sondern nur,
              wenn das jeweilige Unternehmen ein Partnerprogramm hat, an dem wir
              teilnehmen.
            </li>
            <li>
              Nicht alle Links zu externen Websites sind Affiliate-Links – wir
              verlinken auch auf andere Seiten, die für unsere Leser relevant
              und interessant sind.
            </li>
            <li>
              Artikel mit Affiliate-Links enthalten stets einen
              Transparenzhinweis am Anfang oder in der Nähe der Seite: "Wir
              erhalten möglicherweise eine Provision, wenn du über Links auf
              dieser Seite etwas kaufst. Mehr erfahren."
            </li>
          </UnorderedList>
        </p>
        <p>
          Unabhängig davon werden alle Produkte, die wir vorstellen,
          ausschließlich von unseren Redakteuren ausgewählt. Wir empfehlen nur
          Produkte, die wir für wirklich relevant halten. Wir sind sehr
          wählerisch bei der Auswahl unserer Partner und arbeiten nur mit
          Unternehmen zusammen, die unsere Community interessieren und einen
          echten Mehrwert bieten.
        </p>
      </Section>
    </>
  );
}
